import { createStore } from 'vuex'
import { auth } from '../modules/auth/store/index'
import { application } from '../modules/application/store/index'
import { division } from '../modules/division/store/index'
import { project } from '../modules/project/store/index'
import { user } from '../modules/user/store/index'
import { setting } from '../modules/setting/store/index'
import { client } from '../modules/client/store/index'

export type RootState = {
  version: string
  initialized: boolean
  loading: boolean
  statusCode: number
  isOpen: boolean
}

const store = createStore<RootState>({
  state: {
    version: '1.0.0',
    initialized: false,
    loading: false,
    statusCode: 404,
    isOpen: false,
  },
  mutations: {
    INITIALIZED: (state: RootState, status: boolean) => {
      state.initialized = status
    },
    SET_LOADING: (state: RootState, status: boolean) => {
      state.loading = status
    },
    SET_STATUS_CODE: (state: RootState, statusCode: number) => {
      state.statusCode = statusCode
    },
    SET_OPEN_POPUP_TIMEOUT: (state: RootState, open: boolean) => {
      state.isOpen = open
    },
  },
  actions: {
    initialized(ctx, status?: boolean) {
      ctx.commit('INITIALIZED', status)
    },
  },
  getters: {},
  modules: {
    auth,
    application,
    division,
    project,
    user,
    setting,
    client,
  },
})

export default store
